import { render } from "./Ranking.vue?vue&type=template&id=dbce616c"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"
script.render = render

export default script